export interface Category {
	title: string;
	description;
	case_text: string;
	img?: string;
	path: string;
	routing?: string;
	color?: string;
	icon: string;
}

export const categories: Category[] = [
	{
		title: 'startpage.impfschaden.title',
		description: 'startpage.impfschaden.pr_text',
		img: '20250419_Vetopedia_Startseite_Bilder_Impfschaden_v01.webp',
		case_text: 'startpage.impfschaden.counter',
		path: '/impfschaden',
		routing: 'impfschaden',
		color: '#214D87',
		icon: 'vetopedia_Icon_impfung_v01.svg',
	},
	{
		title: 'startpage.mobilfunk.title',
		description: 'startpage.mobilfunk.pr_text',
		case_text: 'startpage.mobilfunk.counter',
		img: '20250419_Vetopedia_Startseite_Bilder_Mobilfunk_v01.webp',
		path: '/mobilfunk',
		routing: 'mobilfunk',
		color: '#3A516E',
		icon: 'vetopedia_Icon_mobilfunk_v01.svg',
	},
	{
		title: 'startpage.pharma_medizinopfer.title',
		description: 'startpage.pharma_medizinopfer.pr_text',
		case_text: 'startpage.pharma_medizinopfer.counter',
		img: '20250419_Vetopedia_Startseite_Bilder_PharmaMedizinopfer_v01.webp',
		path: 'https://v1.vetopedia.org/pharma',
		color: '#7AA4AD',
		icon: 'vetopedia_Icon_PharmaMedizinOpfer_v01.svg',
	},
	{
		title: 'startpage.medien_verleumdungen.title',
		description: 'startpage.medien_verleumdungen.pr_text',
		case_text: 'startpage.medien_verleumdungen.counter',
		img: '20250419_Vetopedia_Startseite_Bilder_Medienverleumdung_v01.webp',
		path: 'https://v1.vetopedia.org/medienverleumdung',
		color: '#A5756D',
		icon: 'vetopedia_Icon_medienverleumdung_v01.svg',
	},
];

// These are the remaining Categories to be added
// {
// 	title: 'startpage.freimaurer_gruendungen.title',
// 		description:
// 	'startpage.freimaurer_gruendungen.pr_text',
// 		case_text: 'startpage.freimaurer_gruendungen.counter',
// 	img: '20250419_Vetopedia_Startseite_Bilder_Medienverleumdung_v01.webp',
// 	path: 'https://v1.vetopedia.org/medienverleumdung',
// 	color: '#A5756D',
// 	icon: 'vetopedia_Icon_medienverleumdung_v01.svg',
// },
// {
// 	title: 'startpage.rituelle_gewalt.title',
// 		description:
// 	'startpage.rituelle_gewalt.pr_text',
// 		case_text: 'startpage.rituelle_gewalt.counter',
// 	img: '20250419_Vetopedia_Startseite_Bilder_Medienverleumdung_v01.webp',
// 	path: 'https://v1.vetopedia.org/medienverleumdung',
// 	color: '#A5756D',
// 	icon: 'vetopedia_Icon_medienverleumdung_v01.svg',
// },
// {
// 	title: 'startpage.inobhutnahme.title',
// 		description:
// 	'startpage.inobhutnahme.pr_text',
// 		case_text: 'startpage.inobhutnahme.counter',
// 	img: '20250419_Vetopedia_Startseite_Bilder_Medienverleumdung_v01.webp',
// 	path: 'https://v1.vetopedia.org/medienverleumdung',
// 	color: '#A5756D',
// 	icon: 'vetopedia_Icon_medienverleumdung_v01.svg',
// },
// {
// 	title: 'startpage.krisenprofit.title',
// 		description:
// 	'startpage.krisenprofit.pr_text',
// 		case_text: 'startpage.krisenprofit.counter',
// 	img: '20250419_Vetopedia_Startseite_Bilder_Medienverleumdung_v01.webp',
// 	path: 'https://v1.vetopedia.org/medienverleumdung',
// 	color: '#A5756D',
// 	icon: 'vetopedia_Icon_medienverleumdung_v01.svg',
// },
// {
// 	title: 'startpage.corona_mitgemacht.title',
// 		description:
// 	'startpage.corona_mitgemacht.pr_text',
// 		case_text: 'startpage.corona_mitgemacht.counter',
// 	img: '20250419_Vetopedia_Startseite_Bilder_Medienverleumdung_v01.webp',
// 	path: 'https://v1.vetopedia.org/medienverleumdung',
// 	color: '#A5756D',
// 	icon: 'vetopedia_Icon_medienverleumdung_v01.svg',
// },

// Just for the backupTexts etc
// const old_categories: Category[] = [
// 	{
// 		title: 'Impfschäden',
// 		description:
// 			'Pharma- und wirtschaftsunabhängige Statistik von Impfungen und deren Schäden',
// 		img: '20250419_Vetopedia_Startseite_Bilder_Impfschaden_v01.webp',
// 		path: 'vaccine-damage',
// 		color: '#214D87',
// 		icon: 'vetopedia_Icon_impfung_v01.svg',
// 	},
// 	{
// 		title: 'Mobilfunkschäden',
// 		description:
// 			'Menschen bezeugen, dass Mobilfunk negative Auswirkungen auf ihre Gesundheit hat!',
// 		img: '20250419_Vetopedia_Startseite_Bilder_Mobilfunk_v01.webp',
// 		path: 'cellphone-damage',
// 		color: '#3A516E',
// 		icon: 'vetopedia_Icon_mobilfunk_v01.svg',
// 	},
// 	{
// 		title: 'Freimaurer-Gründungen',
// 		description:
// 			'Übersicht über Gründungen von Freimaurern und deren Verbindungen untereinander.',
// 		img: '20250419_Vetopedia_Startseite_Bilder_Freimaurerei_v01.webp',
// 		path: 'masonic-foundations',
// 		color: '#54636D',
// 		icon: 'vetopedia_Icon_Freimaurer_v01.svg',
// 	},
// 	{
// 		title: 'Ritueller Missbrauch',
// 		description:
// 			'Sammlung von Zeugenaussagen zu rituellem Missbrauch und Kinderopferungen.',
// 		case_text: 'Fälle',
// 		img: '20250419_Vetopedia_Startseite_Bilder_RituellerMissbrauch_v01.webp',
// 		path: 'ritual-abuse',
// 		color: '#242424',
// 		icon: 'vetopedia_Icon_rituellerMissbr_v01.svg',
// 	},
// 	{
// 		title: 'Kinder-Inobhutnahmen',
// 		description:
// 			'Sammlung von Fällen ungerechtfertigter Inobhutnahmen von Kindern durch staatliche Berhörden',
// 		case_text: 'Inobhutnahmen',
// 		img: '20250419_Vetopedia_Startseite_Bilder_Inobhutnahme_v01.webp',
// 		path: 'children-in-custody',
// 		color: '#75756B',
// 		icon: 'vetopedia_Icon_inobhutnahme_v01.svg',
// 	},
// 	{
// 		title: 'Krisenprofite',
// 		description:
// 			'Sammlung von Profiteuren verschiedener Krisen, deren Hintergründe und Gewinne',
// 		case_text: 'Krisenprofit-Fälle',
// 		img: '20250419_Vetopedia_Startseite_Bilder_Krisenprofit_v01.webp',
// 		path: 'crisis-profits',
// 		color: '#5A777F',
// 		icon: 'vetopedia_Icon_krisenprofit_v01.svg',
// 	},
// 	{
// 		title: 'Corona-Unrecht mitgemacht',
// 		description:
// 			'Zeugenaussagen von Menschen, die beim Corona-Unrecht mitgemacht haben.',
// 		case_text: 'Aussagen',
// 		img: '20250419_Vetopedia_Startseite_Bilder_Corona_v01.webp',
// 		path: 'participated-in-corona-injustice',
// 		color: '#3F6383',
// 		icon: 'vetopedia_Icon_corona_v01.svg',
// 	},
// 	{
// 		title: 'Medien-Verleumdungen',
// 		description:
// 			'Richtigstellungen aus erster Hand - Gegendarstellungen direkt und unzensiert.',
// 		case_text: 'Verleumdungsfälle',
// 		img: '20250419_Vetopedia_Startseite_Bilder_Medienverleumdung_v01.webp',
// 		path: 'media-slander',
// 		color: '#A5756D',
// 		icon: 'vetopedia_Icon_medienverleumdung_v01.svg',
// 	},
// 	{
// 		title: 'Pharma- und Medizinopfer',
// 		description: 'Pharma- und medizinunabhängige Statistik von deren Schäden.',
// 		case_text: 'Schdenfälle',
// 		img: '20250419_Vetopedia_Startseite_Bilder_PharmaMedizinopfer_v01.webp',
// 		path: 'pharma-and-medical-victims',
// 		color: '#7AA4AD',
// 		icon: 'vetopedia_Icon_PharmaMedizinOpfer_v01.svg',
// 	},
// ];
